// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beMZyWQ_XPsrkNm3szjQ.mdc-button.icon-only{min-width:unset}`, "",{"version":3,"sources":["webpack://./src/project-link-button/ProjectLinkButton.module.scss"],"names":[],"mappings":"AAEI,2CACE,eAAA","sourcesContent":[":global {\n  :local(.Button) {\n    &.mdc-button.icon-only {\n      min-width: unset;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Button": `beMZyWQ_XPsrkNm3szjQ`
};
export default ___CSS_LOADER_EXPORT___;
